/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import ArrowNext from '../../assets/pagination-arrow-next.svg';
import ArrowPrevious from '../../assets/pagination-arrow-previous.svg';

const StyledPaginationPagerWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 60px;
	width: 100%;
`;

const StyledArrowWrapper = styled.img`
	margin-top: 2px;
	width: 11px;
	&.previous {
		margin-right: 20px;
		opacity: ${({ previousPagePath }) => (previousPagePath ? 1 : 0)};
	}
	&.next {
		margin-left: 0;
		opacity: ${({ nextPagePath }) => (nextPagePath ? 1 : 0)};
	}
`;

const StyledSingleNumber = styled.div`
	color: ${({ theme }) => theme.colors.lightBlue};
	font-size: 1rem;
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	line-height: 1.375rem;
	margin-right: 20px;
	position: relative;
	text-decoration: none;
	&.active {
		color: ${({ theme }) => theme.colors.darkBlue};
		font-weight: ${({ theme }) => theme.fontWeight.bold};
	}
	&:after {
		background-color: ${({ theme }) => theme.colors.darkBlue};
		content: '';
		display: ${({ hideline }) => (hideline ? 'none' : 'block')};
		height: 16px;
		left: -10px;
		position: absolute;
		top: 3px;
		width: 1px;
	}
`;

const StyledThreeDots = styled.div`
	color: ${({ theme }) => theme.colors.primaryBlue};
	font-family: ${({ theme }) => theme.fontFamily.mainFont};
	font-size: 1rem;
	font-weight: ${({ theme }) => theme.fontWeight.regular};
	line-height: 1.375rem;
	margin-left: -7px;
	margin-right: 10px;
`;

const PaginationPager = ({ pageContext }) => {
	const { previousPagePath, nextPagePath, pageNumber, numberOfPages, prefix } = pageContext;

	const isMoreThanFivePages = numberOfPages > 5;
	const isLessThanFourActive = pageNumber < 3;
	const isAtLeastFourthPage = pageNumber >= 3;
	const isLessThanFourthToEndPage = pageNumber > numberOfPages - 4;

	const currentPageWithBothNeighbours = [];
	for (let i = 0; i <= pageNumber + 1; i++) {
		currentPageWithBothNeighbours.push(i);
	}

	const middlePagesWithBothNeighbours = [];
	for (let j = pageNumber - 1; j < pageNumber + 2; j++) {
		middlePagesWithBothNeighbours.push(j);
	}

	const lastPagesWithNeighbours = [];
	const pagesToEndLeft = isLessThanFourthToEndPage ? numberOfPages - pageNumber + 1 : 1;

	for (let k = numberOfPages - pagesToEndLeft; k < numberOfPages; k++) {
		lastPagesWithNeighbours.push(k);
	}

	return (
		<StyledPaginationPagerWrapper>
			<Link to={`${previousPagePath}#news`}>
				<StyledArrowWrapper className="previous" src={ArrowPrevious} previousPagePath={previousPagePath} />
			</Link>
			{!isMoreThanFivePages &&
				Array.from({ length: numberOfPages }).map((_, i) => (
					<StyledSingleNumber
						key={i}
						className={pageNumber === i ? 'active' : ''}
						as={Link}
						to={`${prefix}/${i > 0 ? i + 1 : ''}#news`}
						hideline={i === 0}
					>
						{i + 1}
					</StyledSingleNumber>
				))}
			{isMoreThanFivePages && (
				<>
					{isAtLeastFourthPage && (
						<>
							<StyledSingleNumber
								key={2}
								className={pageNumber === 0 ? 'active' : ''}
								as={Link}
								to={`${prefix}#news`}
								hideline
							>
								{1}
							</StyledSingleNumber>
							<StyledThreeDots>...</StyledThreeDots>
						</>
					)}
					{isLessThanFourActive &&
						currentPageWithBothNeighbours.map((item) => (
							<StyledSingleNumber
								key={item}
								className={pageNumber === item ? 'active' : ''}
								as={Link}
								to={`${prefix}/${item > 0 ? item + 1 : ''}#news`}
								hideline={item === 0}
							>
								{item + 1}
							</StyledSingleNumber>
						))}
					{isAtLeastFourthPage &&
						!isLessThanFourthToEndPage &&
						middlePagesWithBothNeighbours.map((item) => (
							<StyledSingleNumber
								key={item}
								className={pageNumber === item ? 'active' : ''}
								as={Link}
								to={`${prefix}/${item > 0 ? item + 1 : ''}#news`}
								hideline={item === pageNumber - 1}
							>
								{item + 1}
							</StyledSingleNumber>
						))}
					{!isLessThanFourthToEndPage && <StyledThreeDots>...</StyledThreeDots>}
					{lastPagesWithNeighbours.map((item) => (
						<StyledSingleNumber
							key={item}
							className={pageNumber === item ? 'active' : ''}
							as={Link}
							to={`${prefix}/${item > 0 ? item + 1 : ''}#news`}
							hideline={
								(!isLessThanFourthToEndPage && item === numberOfPages - 1) ||
								(isLessThanFourthToEndPage && item === numberOfPages - pagesToEndLeft)
							}
						>
							{item + 1}
						</StyledSingleNumber>
					))}
				</>
			)}
			<Link to={`${nextPagePath}#news`}>
				<StyledArrowWrapper className="next" src={ArrowNext} nextPagePath={nextPagePath} />
			</Link>
		</StyledPaginationPagerWrapper>
	);
};

export default PaginationPager;
